import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ECommerce } from 'api/AppConfigApi';
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import { getProduct } from "api/ProductApi";
import RemoveCart from "components/RemoveCart";
import { filterFormatToDate } from "utility/Constant";
import { getCustomerId } from "utility/HeaderConfig";
import { useCartContext } from "context/UseCartContext";
import { getAddToCart, getBranchId } from "utility/HeaderConfig";
import Noimg from "../images/no_img.jpg";
import { getProductCate } from "../api/ProductCategoryApi";
import { getPageProductType } from "api/ProductTypeApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import { genderBasedIcons } from "../components/GenderBasedIcons.js";
import { Button } from 'reactstrap';
import CheckoutProgressBar from "components/CheckoutProgressBar";
import { ChevronDown, ChevronUp, ChevronLeft } from "lucide-react";
import logo182 from "../images/assets/logo182.svg"
import logo192 from "../images/assets/logo192.webp"
import logo205 from "../images/assets/logo205.webp"
import logo from "../images/assets/sreeMayuriLogo.png"
import secure from "../images/assets/secure.svg"
import { branchdetails } from "api/BranchDetailsApi";
import { isMobile } from 'react-device-detect';


const StyledDiv = tw.div`font-display overflow-hidden`;

export default ({ configImages }) => {
  const [BranchMobile, setBranchMobile] = useState("");
  const [verifyAmount, setVerifyAmount] = useState(0);
  const [validation, setValidation] = useState(true);
  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState([]);
  const [showModal, setShowModal] = useState("");
  const [banner, setBanner] = useState([]);
  const history = useNavigate();
  const location = useLocation();
  const myparam = location?.state?.viewCart;
  const { dispatch, data } = useCartContext();
  const [address, setAddress] = useState(true);
  const [payment, setPayment] = useState(false);
  const [occationCate, setOccationCate] = useState([]);
  const [productSubCate, setProductSubCate] = useState([]);
  const [productCategory, setCategoryList] = useState([]);
  const [productType, setProductType] = useState([]);
  const [data1, setData1] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [Details, setDetails] = useState([]);
  const [prdctId, setPrdctId] = useState([]);
  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    Price: "",
    status: "available",
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (myparam) {
      setViewCart(history?.location?.state?.propValueData)
    } else {
      viewCartList();
      getBanner();
    }
    //eslint-disable-next-line
  }, [data]);

  // useEffect(() => {
  //   if (myparam) {
  //     setViewCart(myparam);
  //     calcTotal(myparam);
  //   } else {
  //     viewCartList();
  //   }
  //   //eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if (data && data.length) {
      setViewCart(data);
      calcTotal(data);
    } else {
      setViewCart([]);
      setTotal(0);
    }
  }, [data]);


  useEffect(() => {
    getBanner();
    getPriceCheck();
    viewCartList();
    getProductType();
    getProductType2();
    getCategoryList1();
    getProductSub();
    getOurExclusiveData();
    getbranchdetails();
    //eslint-disable-next-line
  }, []);

  const getbranchdetails = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranchMobile(data.response.mobile);
    });
  };

  const getProductType = async () => {
    let pList = [];
    // setListLoading(true);
    await getPageProductType({ active: 1 }).then((data) => {
      // setListLoading(true);
      productType.length = 0;
      let response = data.response.content;
      pList = response.filter(
        (data) => data.metaProductCategoryList.length > 0 && data.id
      );
      pList.reverse();
      for (let index = 0; index < pList.length; index++) {
        productType.push(pList[index]);
      }
      setProductType(productType);
      // setListLoading(false);
    });
  };
  const getProductType2 = () => {
    getPageProductType({}).then((data) => {
      let response = data.response.content;
      let filterData = response.filter((data) => {
        if (data.metaProductCategoryList.length > 0) {
          const typeName = data.name.toLowerCase().trim();
          return (
            typeName === "gold" ||
            typeName === "silver" ||
            typeName === "silver articles" ||
            // typeName === "gift articles" ||
            typeName === "diamond" ||
            typeName === "platinum"
          );
        }
        else {
          return false
        }
      });
      filterData.reverse()
      setData1(filterData);
    });
  };
  const getCategoryList1 = async () => {
    // setListLoading(true);
    let visibilityList = [];
    let filterData = {

      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    await getAllProductCate(filterData).then((data) => {
      const productResponse = data.response;
      let limitedData = productResponse.slice(0, 150)
      visibilityList = productResponse.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE"
      );
      setCategoryList(visibilityList);

      // setListLoading(false);
    });
  };

  const getProductSub = async () => {
    // setListLoading(true);
    let visibilityList = [];
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      metaProdCateEnty: selectedList.category ? selectedList.category : "",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    if (filterData.metaProdCateEnty === "") {
      delete filterData.metaProdCateEnty;
    }
    await getAllProductSubCate(filterData).then((data) => {
      let response = data.response

      let limitedData = response.slice(0, 300);
      visibilityList = response.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE"
      );

      setProductSubCate(limitedData);
      // setListLoading(false);
    });
  };

  const getOurExclusiveData = () => {
    getProductCate({
      visibilityMode: "DESIGN",
    })
      .then((data) => {
        setOccationCate(data.response.content);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const calcTotal = (cartList) => {
    setValidation(true);
    let totalCartValue = 0;
    cartList &&
      cartList.forEach((data) => {
        if (data.total > 0) {
          totalCartValue += data.total;
        }
      });
    const isSoldProductAvailable =
      cartList.length > 0 &&
      cartList.some((data) => data.statusName?.toLowerCase() === "sold");
    if (isSoldProductAvailable) setValidation(false);
    setTotal(totalCartValue);
  };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "cart") {
          setBanner(data.value);
        }
      });
  };

  const viewCartList = () => {
    let dataList = [];
    let basePrice = 0;
    let total = 0;
    let cgst = 0;
    let sgst = 0;
    const prdtArr = getAddToCart() && JSON.parse(getAddToCart());
    const branch = getBranchId();
    // const filterprdt = prdtArr.filter(
    //   (cartItem) => cartItem.branch === branch
    // );
    const newArray = prdtArr;
    if (newArray?.length > 0) {
      newArray &&
        newArray.forEach((element, index) => {
          let filter = {
            branch: getBranchId(),
            id: element.id,
            beforeCreatedAt: filterFormatToDate(moment().format("YYYY-MM-DD")),
          };
          const respData = getProduct(10, filter);
          respData.then((res) => {
            dataList.push(res.response.content[0]);
            newArray &&
              newArray.forEach((element, index) => {
                if (dataList.length - 1 === index) {
                  if (dataList[index]?.basePrice) {
                    basePrice += Number(dataList[index]?.basePrice);
                  }
                  if (dataList[index]?.total) {
                    total += Number(dataList[index]?.total);
                  }
                  if (dataList[index].saleTaxList[1]?.amount) {
                    cgst += Number(dataList[index]?.saleTaxList[1]?.amount);
                  }
                  if (dataList[index].saleTaxList[0]?.amount) {
                    sgst += Number(dataList[index]?.saleTaxList[0]?.amount);
                  }
                  let totalAmount = 0;
                  if (dataList.length > 0) {
                    totalAmount = dataList.reduce((result, item) => {
                      return (result += parseFloat(Math.trunc(item.total)));
                    }, 0);
                  }
                  setTotal(totalAmount);
                  setViewCart(dataList);
                }
              });
            let Rate = res.response?.content[0] ?? "";
            let ProductDetail = res.response.content[0];
            let Certificate;
            ProductDetail?.length > 0 && JSON.parse(ProductDetail?.otherCharges).map((value) => {
              if (value?.stone && value?.stone?.length > 0) {
                Certificate = value.stone[0].certificatenumber;
              }
            });
            const weight = ProductDetail?.length > 0 && JSON.parse(ProductDetail.weight);
            setDetails({
              ...ProductDetail,
              ...Rate,
              Certificate,
              weight,
            });
            setPrdctId(res.response.content[0].id);
          });
        });
    }
  };

  const removeItemFromCart = (code) => {
    let productData = JSON.parse(getAddToCart());
    const updatedCart = productData.filter(item => item.productCode !== code);

    reactLocalStorage.set("CartList", JSON.stringify(updatedCart));
    dispatch({ type: "ADD", payload: updatedCart });

    toast.success("Product Removed From the Cart!", {
      duration: 3000,
      position: "top-right",
    });

    setShowModal("");
  };


  const checkout = () => {
    if (total <= verifyAmount) {
      if (getCustomerId()) {
        history("/CheckoutPage", { state: { Details, prdctId } });
      } else {
        dispatch({ type: "MODAL", payload: "login" });
      }
    } else {
      toast.error(`The Purchase Amount Is Shouldn't Be Greater Than ${verifyAmount}`, {
        position: "top-right",
        duration: 3000
      })
    };
  };

  const getPriceCheck = async () => {

    let filter = 'sales_threshold';
    let appConfigResData = await ECommerce(filter);
    let appConfigthresholdValue = JSON.parse(appConfigResData.response.moduleField);
    let saleThresholdValue = 0;
    Object.entries(appConfigthresholdValue).forEach((entry) => {
      if (entry[0] === "sales_threshold_amount") {
        saleThresholdValue = entry[1];
      }
    });
    setVerifyAmount(saleThresholdValue);
  }

  const handleClick = (number) => {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      window.location.replace(`tel:${number}`);
    } else if (window.matchMedia("(max-width: 425px)").matches || isMobile) {
      window.location.href = `tel:${number}`;
    } else {
      console.log(number, "website");
      setIsOpen(true);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };


return (
  <StyledDiv>
    <Toaster position="top-right" />
    {banner && banner.length > 0 ? (
      <>
        <div className="container d-flex justify-content-center align-items-center">
          <Link to="/"> <img width="60px" src={logo} /> </Link>
          <div className="w-75 mx-auto">
            <CheckoutProgressBar address={address} payment={payment} />
          </div>
          <img width="70px" src={secure} />
        </div>
      </>
    ) : (
      <Skeleton tw="w-full" style={{ height: "200px" }} />
    )}

    <div className="container-xl">
      {viewCart?.length > 0 ? (
        <div className="row">
          <div className="col-lg-8">
            {viewCart.map((list, index) => (
              <div key={list.skv || index}>
                <div className="container-xl">
                  <div className="row p-sm-4 border-0 shadow-sm" tw="rounded-t-lg">
                    <div className="col-sm-3 p-0 p-auto">
                      <h6 className="mb-4"><small>TOTAL ITEM {index + 1}</small></h6>
                      <img
                        src={
                          list?.images?.includes("@#@") && list?.images !== "@#@"
                            ? list?.images.split("@#@")[0]
                            : Noimg
                        }
                        alt="Jai Maruthi Jewellery"
                        className="m-auto"
                        tw="sm:w-full w-40"
                      />
                    </div>
                    <div className="col-sm-9 mt-5">
                      <div className="ms-sm-4 position-relative">
                        <h4 tw="text-xl mb-3 sm:mt-0 mt-5 block">
                          {list.title}
                          <i 
                            onClick={() => setShowModal(list.skv)}
                            className="bi bi-x position-absolute end-0 top-0"
                            tw="text-4xl text-yellow-600 cursor-pointer"
                          ></i>
                        </h4>
                        
                        <div className="d-flex justify-content-between col-md-8">
                          <div tw="w-48">
                            <p tw="text-base flex font-medium" className="ptSans justify-content-between">
                              Metal <span>:</span>
                            </p>
                          </div>
                          <p tw="text-base flex" className="ptSans px-4 w-100">
                            {list.metalType}{" "}
                          </p>
                        </div>
                        
                        <div className="d-flex justify-content-between col-md-8">
                          <p tw="text-base flex font-medium w-48" className="ptSans justify-content-between">
                            Product Code <span>:</span>
                          </p>
                          <p tw="text-base" className="ptSans px-4 w-100">
                            {list.skv}{" "}
                          </p>
                        </div>

                        <div className="d-flex col-md-8 justify-content-between">
                          <p tw="text-base flex font-medium w-48" className="ptSans justify-content-between">
                            size <span>:</span>
                          </p>
                          <p tw="text-base flex" className="ptSans px-4 w-100">
                            19
                          </p>
                        </div>

                        <div className="d-flex col-md-8 justify-content-between">
                          <p tw="text-base flex font-medium w-48" className="ptSans justify-content-between">
                            Qty<span>:</span>
                          </p>
                          <p tw="text-base flex" className="ptSans px-4 w-100">
                            {list.quantity}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end align-items-center mt-3">
                      <span className="total-price-label">
                        Total Price:
                        {list?.total !== list?.discountAmt && list?.discountAmt > 0 ? (
                          <span className="price-column ms-2">
                            <span className="final-price">₹{list?.discountAmt?.toFixed(2)}</span>
                            <span className="original-price text-muted text-decoration-line-through ms-2">
                              ₹{list?.total?.toFixed(2)}
                            </span>
                            <span className="discount-text text-success ms-2">
                              {list?.discountType === 'percentage'
                                ? `${list?.discountValue}% off`
                                : `${list?.discountValue} Rs off`}
                            </span>
                          </span>
                        ) : (
                          <span className="final-price ms-2">₹{list?.total?.toFixed(2)}</span>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                
                {list?.statusName?.toLowerCase() === "sold" && (
                  <div className="mt-2">
                    <span style={{ color: "red" }}>
                      * This Item is Sold Please Remove this Item
                    </span>
                  </div>
                )}
                {/* <div className="mt-2 text-end">
                  <span onClick={() => setShowModal(list.skv)} className="text-danger cursor-pointer">
                    <i className="bi bi-trash3-fill mx-2"></i> Remove
                  </span>
                </div> */}
              </div>
            ))}
            
            <div className="col-10 col-sm-5 col-lg-3 py-3">
              <div
                onClick={() => {
                  setSelectedList((prev) => ({ ...prev, type: data.id }));
                  navigate("/");
                }}
                className="d-flex align-items-center justify-content-evenly p-2"
              >
                <div
                  className="d-flex justify-content-center align-items-center gap-2 rounded"
                  style={{
                    border: "1px solid #f0b917",
                    height: 40,
                    padding: "0 16px",
                    color: "#f0b917",
                    whiteSpace: "nowrap",
                  }}
                >
                  <ChevronLeft size={18} />
                  <span>Continue Shopping</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="price-detail-section orderItem-box rounded mt-lg-5" tw="border border-custom-100 border-dashed">
              <p className="text-success mb-2 fw-bold text-black">
                Order Summary ({viewCart?.length || 0}) {`${(viewCart?.length || 0) === 1 ? "Item" : "Items"}`}
              </p>

              <div className="row">
                <div className="label-col col-sm-7 col ">
                  <div>
                    <span className="you-pay fw-bold">Total payable</span>
                    <div>
                      <span className="inc-tax" tw="text-xs">
                        (Incl of all taxes.)
                      </span>
                    </div>
                  </div>
                </div>
                <div className="price-col col-sm-5 col mt-2">
                  <span className="you-pay-amt fw-bold text-uppercase">
                    <span>₹ </span>
                    <span>
                      {viewCart.reduce((total, item) => {
                        const itemPrice = item?.total !== item?.discountAmt && item?.discountAmt > 0 
                          ? item.discountAmt 
                          : item.total;
                        return total + (parseFloat(itemPrice) || 0);
                      }, 0).toFixed(2)}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            
            <button
              style={{ background: " #f0b917" }}
              className="px-5 py-3 my-2 mt-2 rounded text-white w-100"
              tw="font-semibold tracking-wide"
              onClick={checkout}
              disabled={!validation}
            >
              CHECKOUT SECURELY
            </button>

            <div className="shadow-lg mt-4 p-3 text-center text-black">
              <h6><small>Have any queries? Contact us for your assistance </small></h6>
              <h6>
                <small>
                  Call us at
                  <span style={{ marginLeft: "5px" }}>
                    <Link className="text-info" onClick={() => handleClick(BranchMobile)}>
                      {BranchMobile}
                    </Link>
                  </span>
                </small>
              </h6>
              {isOpen && (
                <div tw="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50 mt-[-10px]">
                  <div tw="bg-white rounded-lg p-4 w-1/4 flex flex-col items-center -mt-40">
                    <p tw="text-lg mb-4">Calls are not supported on website.</p>
                    <button
                      className="rounded-pill shadow-sm"
                      tw="bg-[#b9f0ff] hover:bg-[#f0b917] text-black font-bold py-2 px-4 rounded"
                      onClick={handleClose}
                    >
                      OK
                    </button>
                  </div>
                </div>
              )}
            </div>

            {!validation && (
              <div className="mt-3">
                <span style={{ color: "red" }}>
                  * One of the item is Sold on your cart. Please Remove & Proceed
                </span>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="w-100 py-3">
          <div className="cart-wrapper">
            <div className="cart-empty-wrapper text-center">
              <div className="col-md-12 empty-wrapper">
                <img
                  className="trash-icon m-auto"
                  tw=" w-3/5 sm:w-1/4"
                  alt="cart empty img"
                  src={logo182}
                />
                <h3 tw="uppercase py-5 font-extrabold">
                  <h6 className="text-black"> Oops! Your bag is empty! </h6>
                  <h6> <small>Let's shop some jewels and fill it.</small></h6>
                </h3>
                <button
                  style={{ backgroundColor: " #f0b917" }}
                  className="primary-btn cart-btns false text-white py-3 px-5 rounded"
                  onClick={() => history("/ProductList")}
                >
                  START SHOPPING
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    
    {showModal && (
      <>
        <RemoveCart
          setShowModal={() => setShowModal("")}
          showModal={showModal}
          removeItemFromCart={removeItemFromCart}
        />
        <div tw="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )}
  </StyledDiv>
);
};

